import { render } from "./RiskAssessmentTab.vue?vue&type=template&id=6bb2e81b&scoped=true"
import script from "./RiskAssessmentTab.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentTab.vue?vue&type=script&lang=js"

import "./RiskAssessmentTab.vue?vue&type=style&index=0&id=6bb2e81b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb2e81b"]])

export default __exports__